import type React from "react";
// Shared with mobile via frontend/packages/assets — reached by relative path,
// the same way the locale flags are.
import { ReactComponent as RecommendSessionIcon } from "../../../../../../../../packages/assets/chat-starters/recommend-session.svg";
import { ReactComponent as ScoresMeaningIcon } from "../../../../../../../../packages/assets/chat-starters/scores-meaning.svg";
import { ReactComponent as SleepBetterIcon } from "../../../../../../../../packages/assets/chat-starters/sleep-better.svg";
import { ReactComponent as StressPatternsIcon } from "../../../../../../../../packages/assets/chat-starters/stress-patterns.svg";
import { ReactComponent as StressfulSituationIcon } from "../../../../../../../../packages/assets/chat-starters/stressful-situation.svg";
import type { ChatStarterId } from "../chat-starters";

/**
 * One icon per starter, keyed by id rather than position — the pills are
 * shuffled on every display, and the design frame lists them in a different
 * order again.
 */
export const STARTER_ICONS: Record<
  ChatStarterId,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  recommendSession: RecommendSessionIcon,
  stressfulSituation: StressfulSituationIcon,
  sleepBetter: SleepBetterIcon,
  scoresMeaning: ScoresMeaningIcon,
  stressPatterns: StressPatternsIcon,
};
